/**
 * Custom Buy It Now Button (No PayPal)
 * Redirects directly to checkout with selected variant
 */

(function () {
  "use strict";

  function initCustomBuyNow() {
    document.addEventListener("click", function (e) {
      var btn = e.target.closest(".custom-buy-now");

      if (btn) {
        e.preventDefault();

        // Check if button is disabled
        if (btn.disabled || btn.classList.contains("disabled")) {
          return;
        }

        // Get variant ID and quantity
        var variantId = btn.dataset.variantId;
        var quantity = parseInt(btn.dataset.quantity) || 1;

        // Update variant ID from selector if changed
        var form = btn.closest("form");
        if (form) {
          var variantIdInput = form.querySelector('[name="id"]');
          if (variantIdInput && variantIdInput.value) {
            variantId = variantIdInput.value;
          }

          // Get quantity from input
          var qtyInput = form.querySelector('[name="quantity"]');
          if (qtyInput && qtyInput.value) {
            quantity = parseInt(qtyInput.value) || 1;
          }
        }

        if (!variantId) {
          alert("Please select a product option.");
          return;
        }

        // Show loading state
        btn.disabled = true;
        btn.classList.add("loading");

        // Add to cart first, then redirect to checkout
        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: variantId,
            quantity: quantity,
          }),
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (data) {
            // Redirect to checkout
            window.location.href = "/checkout";
          })
          .catch(function (error) {
            console.error("Error:", error);
            alert("Failed to add product to cart. Please try again.");

            // Restore button state
            btn.disabled = false;
            btn.classList.remove("loading");
          });
      }
    });

    // Update variant ID when variant changes
    document.addEventListener("change", function (e) {
      if (
        e.target.name === "id" &&
        e.target.closest("form") &&
        e.target.closest("form").querySelector(".custom-buy-now")
      ) {
        var buyNowBtn = e.target
          .closest("form")
          .querySelector(".custom-buy-now");
        buyNowBtn.dataset.variantId = e.target.value;
      }
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCustomBuyNow);
  } else {
    initCustomBuyNow();
  }
})();
